export default {
  America_Los_Angeles: "America/Los_Angeles",
  America_New_York: "America/New_York",
  America_Chicago: "America/Chicago",
  America_Denver: "America/Denver",
  America_Anchorage: "America/Anchorage",
  Pacific_Honolulu: "Pacific/Honolulu"
}
